import { BREAKPOINTS } from './breakpoints';
import { LiveblogTenant } from '../typings/liveblog-themes';

/**
 *  Utility function to check if we are in browser context of in Server or Node.js env.
 */
export const isServer = () => typeof window === 'undefined';

/**
 * Utility function to check if we are in browser context of in NodeJS env.
 */
export const isClient = (force?: boolean | undefined): boolean =>
  typeof force === 'boolean' ? force : typeof window !== 'undefined';

/**
 * Check if is Landscape for SSR is false
 */
export const isLandscapeOriented = (): boolean =>
  isClient() ? window.matchMedia('(orientation: landscape)').matches : false;

/**
 * Check if is Portrait for SSR true
 */
export const isPortraitOriented = (): boolean =>
  isClient() ? window.matchMedia('(orientation: portrait)').matches : true;

/**
 * is Mobile Device
 * iPhone iPad iPod Android
 */
export const isMobile = (): boolean => {
  if (isClient()) {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || false;
  } else {
    return false;
  }
};

/**
 * Get Window Width or SSR BREAKPOINTS.MOBILE
 */
export const getWindowWidth = (): number => {
  if (isClient()) {
    return window?.innerWidth || document?.documentElement?.clientWidth || document?.body?.clientWidth;
  } else {
    return BREAKPOINTS.MOBILE;
  }
};

export const isSportWebView = (isWebView?: boolean, tenant?: LiveblogTenant) => isWebView && tenant === 'sport';
export const isTG24WebView = (isWebView?: boolean, tenant?: LiveblogTenant) => isWebView && tenant === 'tg24';
